<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="main">
  <mat-dialog-content>
    <h2 class="main--text">{{ 'extendTransfer' | i18next }}</h2>
  </mat-dialog-content>
  <mat-dialog-content>
    <h5 class="main--text">{{ 'textExtend' | i18next }}</h5>
  </mat-dialog-content>
  <div class="approvers">
    <app-approvers
      class="controller"
      [type]="'TRANSFERS'"
      [extendTransfer]="true"
      (selectionAuthorizers)="onSelectionAuthorizers($event)"
    ></app-approvers>
  </div>
  <form [formGroup]="form" class="main--form">
    <mat-form-field>
      <mat-label>{{ 'returnDate' | i18next }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        formControlName="extendDate"
        [min]="minDate"
        readonly
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker (closed)="close()"></mat-datepicker>
    </mat-form-field>
  </form>
  <mat-dialog-actions>
    <button type="button" class="btn btn-cancel" mat-dialog-close>
      {{ 'altCancel' | i18next | uppercase }}
    </button>
    <button
      type="submit"
      class="btn"
      (click)="submitRequest()"
      [disabled]="form.invalid || !controller.id"
    >
      {{ 'stepConfirm' | i18next | uppercase }}
    </button>
  </mat-dialog-actions>
</main>
